import React, {
  FC, useMemo, useState,
} from 'react';
import _ from 'lodash';
import { Badge } from 'reactstrap';

import history from 'app/routes/history';
import Table from 'app/components/general/TableNew';
import Button from 'app/components/general/Button';
import PlusIcon from 'app/images/icons/plus.svg';

import * as notificationConfigSelectors from 'app/ducks/notificationConfigs/selectors';

interface IProps {
  actions: any;
  notificationConfigsById: any[];
  notificationConfigIds: string[];
  teamId?: string;
  headerTitle?: string;
  appReady?: boolean;
  isLoading?: boolean;
  manual?: boolean;
  saveFilters?: boolean;
  initialFilterConfig?: any;
  persistentFilterConfig?: any;
  pagination?: any;
  selectTeam: (value) => void;
}

const NotificationConfigsTable: FC<IProps> = (props: IProps = {
  manual: true,
  actions: undefined,
  notificationConfigsById: undefined,
  notificationConfigIds: undefined,
  initialFilterConfig: {},
  persistentFilterConfig: {},
  isLoading: false,
  pagination: undefined,
  selectTeam: undefined,
}) => {
  const fetchDataFromApi = ({
    sort, filter, pageNumber, pageSize,
  }): void => {
    if (
      props.appReady
      && !props.isLoading
      && (pageNumber !== props.pagination.page.number
        || (!_.isEmpty(sort) && sort !== props.pagination.sort)
        || filter !== props.pagination.filter)
    ) {
      props.actions.getAllNotificationConfigs({
        page: {
          size: pageSize,
          number: pageNumber,
        },
        sort,
        filter,
      });
    }
  };

  const handleClick = (id: string): void => {
    props.actions.selectNotificationConfig(id);
    history.push(`/notification-contacts/${id}`);
  };

  const data = useMemo(() => {
    if (_.isEmpty(props.notificationConfigsById) || props.notificationConfigIds === undefined) {
      return [];
    }
    const notificationConfigRows = _.reduce(
      props.notificationConfigIds,
      (acc, id) => {
        const fee = props.notificationConfigsById[id];
        if (!_.isEmpty(fee) && fee.status === 'active') {
          acc.push(notificationConfigSelectors.getNotificationConfigSummary(fee));
        }
        return acc;
      },
      [],
    );

    return notificationConfigRows;
  }, [props.notificationConfigsById, props.notificationConfigIds]);

  const columns = useMemo(() => [
    {
      Header: 'Type',
      accessor: 'notificationType',
      className: 'col',
      headerClassName: 'col',
      Cell: (cellProps): React.ReactNode => _.map(cellProps.value, (tag, key) => (
        <Badge className="extra-padding" key={key} color={tag.colour}>
          {tag.text}
        </Badge>
      )),
    },
    {
      Header: 'Name',
      className: 'col',
      headerClassName: 'col',
      accessor: 'name',
    },
    {
      Header: 'Email',
      className: 'col',
      headerClassName: 'col',
      accessor: 'email',
    },
    {
      Header: 'Mobile',
      className: 'col',
      headerClassName: 'col',
      accessor: 'mobile',
    },
  ], []);

  const counterText = props.pagination.meta.totalCount === 1 ? '1 contact' : `${props.pagination.meta.totalCount || 0} contacts`;

  return (
    <div>
      <Table
        data={data}
        columns={columns}
        isLoading={props.isLoading}
        // aggressiveLoader
        headerTitle={props.headerTitle}
        objectTitle="match payments"
        filterTitle="Match Payments Data"
        counterText={counterText}
        handleClick={handleClick}
        filterable={false}
        manualSortBy={false}
        saveFilters={props.saveFilters}
        manual={props.manual}
        fetchDataFromApi={fetchDataFromApi}
        // filterOptions={filterOptions}
        filterConfig={props.initialFilterConfig}
        persistentFilterConfig={props.persistentFilterConfig}
        pagination={props.pagination}
        showPagination
      >
        <Button
          onClick={() => history.push('/create-notification-contact')}
          btnIcon={PlusIcon}
          className="btn-thinner btn-2"
        >
          Create Contact
        </Button>
      </Table>
    </div>
  );
};

export default NotificationConfigsTable;
